// frontend/src/components/common/ProtectedPage.jsx
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import PermissionDeniedAlert from './PermissionDeniedAlert';

/**
 * Componente wrapper para proteger páginas inteiras com verificação de permissão
 * 
 * @param {Object} props
 * @param {string} props.permission - Permissão necessária
 * @param {React.ReactNode} props.children - Conteúdo da página
 * @param {string} [props.loadingText] - Texto personalizado do loading
 * @param {string} [props.requiredPermission] - Nome da permissão para exibição na mensagem de erro
 * @param {string} [props.action] - Ação para exibição na mensagem de erro (ex: "visualizar esta página")
 */
export default function ProtectedPage({ 
  permission, 
  children, 
  loadingText = 'Carregando...', 
  requiredPermission,
  action 
}) {
  const { loading: authLoading, hasPermission } = useAuth();

  // Aguarda autenticação
  if (authLoading) {
    return <LoadingSpinner text="Verificando sessão..." />;
  }

  // Verifica permissão
  if (!hasPermission(permission)) {
    return (
      <PermissionDeniedAlert
        requiredPermission={requiredPermission || permission}
        action={action}
      />
    );
  }

  // Renderiza o conteúdo protegido
  return <>{children}</>;
}
